export enum VariablesEnum {
  variables = 'variables',
  prompts = 'prompts',
}

export const promptLibraryVariables = [
  'agent_name',
  'RAG',
  'TodayDateTime',
  'SpeakLanguage',
  'PageHeaders',
  'PageSubHeaders',
  'PageUrl',
  'PageTitle',
  'ConversationChannel',
  'UserPhone',
  'InboundPhone',
  'OutboundPhone',
  'participant_info_metadata',
  'AvailableLanguagesSwitch',
  'ConferenceCallInfo',
  'presentationContent',
].sort();
